import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../authentication/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (
      this.authService.isAccessTokenExpired() &&
      this.authService.isRefreshTokenExpired()
    ) {
      this.authService.onLogOut();
    }

    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
    if (this.authService.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/auth/login/']);
      return false;
    }
  }
}
